import { uniqueId } from "lodash";
import { customTemplates } from "../../CustomTemplates.js";
import { DataStore } from "../data/DataStore.js";
import { setupTemplateProxy } from "./setupTemplateProxy.js";
import { setupUseBrickInTemplate } from "./setupUseBrickInTemplate.js";
import { childrenToSlots } from "../Renderer.js";
import { hooks } from "../Runtime.js";
import { replaceSlotWithSlottedBricks } from "./replaceSlotWithSlottedBricks.js";
import { isolatedTemplateRegistryMap } from "../IsolatedTemplates.js";
export function expandCustomTemplate(tplTagName, brickConf, hostBrick, asyncHostPropertyEntries, rendererContext) {
  var _hooks$flowApi;
  const tplStateStoreId = uniqueId("tpl-state-");
  const runtimeContext = {
    ...hostBrick.runtimeContext,
    tplStateStoreId
  };

  // There is a boundary for `forEach*` and `FORM_STATE` between template internals and externals.
  delete runtimeContext.forEachItem;
  delete runtimeContext.forEachIndex;
  delete runtimeContext.forEachSize;
  delete runtimeContext.formStateStoreId;
  const tplStateStore = new DataStore("STATE", hostBrick, rendererContext, tplStateStoreId);
  runtimeContext.tplStateStoreMap.set(tplStateStoreId, tplStateStore);
  if (runtimeContext.tplStateStoreScope) {
    runtimeContext.tplStateStoreScope.push(tplStateStore);
  }
  const {
    bricks,
    proxy,
    state,
    contracts
  } = hostBrick.runtimeContext.isolatedRoot ? isolatedTemplateRegistryMap.get(hostBrick.runtimeContext.isolatedRoot).get(tplTagName) : customTemplates.get(tplTagName);
  hooks === null || hooks === void 0 || (_hooks$flowApi = hooks.flowApi) === null || _hooks$flowApi === void 0 || _hooks$flowApi.collectWidgetContract(contracts);
  tplStateStore.define(state, runtimeContext, asyncHostPropertyEntries);
  const {
    slots: originalExternalSlots,
    children: externalChildren,
    ...restBrickConf
  } = brickConf;
  const newBrickConf = {
    ...restBrickConf,
    brick: tplTagName
  };
  hostBrick.tplHostMetadata = {
    internalBricksByRef: new Map(),
    tplStateStoreId,
    proxy
  };

  // Reversed proxies are used for expand storyboard before rendering page.
  const reversedProxies = {
    properties: new Map(),
    slots: new Map()
    // mergeBases: new Map(),
  };
  if (proxy !== null && proxy !== void 0 && proxy.properties) {
    for (const [from, to] of Object.entries(proxy.properties)) {
      let proxies = reversedProxies.properties.get(to.ref);
      if (!proxies) {
        proxies = [];
        reversedProxies.properties.set(to.ref, proxies);
      }
      proxies.push({
        from,
        to
      });
    }
  }
  if (proxy !== null && proxy !== void 0 && proxy.slots) {
    for (const [from, to] of Object.entries(proxy.slots)) {
      let proxies = reversedProxies.slots.get(to.ref);
      if (!proxies) {
        proxies = [];
        reversedProxies.slots.set(to.ref, proxies);
      }
      proxies.push({
        from,
        to
      });
    }
  }
  const hostContext = {
    reversedProxies,
    asyncHostPropertyEntries,
    externalSlots: childrenToSlots(externalChildren, originalExternalSlots),
    tplStateStoreId,
    hostBrick: hostBrick,
    usedSlots: new Set()
  };
  newBrickConf.slots = {
    "": {
      type: "bricks",
      bricks: bricks.flatMap(item => expandBrickInTemplate(item, hostContext))
    }
  };
  return newBrickConf;
}
function expandBrickInTemplate(brickConfInTemplate, hostContext, markSlotted) {
  // Ignore `if: null` to make `looseCheckIf` working.
  if (brickConfInTemplate.if === null) {
    delete brickConfInTemplate.if;
  }
  if (brickConfInTemplate.brick === "slot") {
    markSlotted === null || markSlotted === void 0 || markSlotted();
    return replaceSlotWithSlottedBricks(brickConfInTemplate, hostContext, expandBrickInTemplate);
  }
  const {
    properties,
    slots: slotsInTemplate,
    children: childrenInTemplate,
    ...restBrickConfInTemplate
  } = brickConfInTemplate;
  const transpiledSlots = childrenToSlots(childrenInTemplate, slotsInTemplate);
  let slotted = false;
  const markChild = () => {
    slotted = true;
  };
  const slots = Object.fromEntries(Object.entries(transpiledSlots !== null && transpiledSlots !== void 0 ? transpiledSlots : {}).map(_ref => {
    var _slotConf$bricks;
    let [slotName, slotConf] = _ref;
    return [slotName, {
      type: "bricks",
      bricks: ((_slotConf$bricks = slotConf.bricks) !== null && _slotConf$bricks !== void 0 ? _slotConf$bricks : []).flatMap(item => expandBrickInTemplate(item, hostContext, markChild))
    }];
  }));
  return {
    ...restBrickConfInTemplate,
    properties: setupUseBrickInTemplate(properties, hostContext),
    slots,
    ...setupTemplateProxy(hostContext, restBrickConfInTemplate.ref, slots, slotted)
  };
}
//# sourceMappingURL=expandCustomTemplate.js.map